// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Counter from "./counter";
import Navbar from "./components/commonComponents/navbar";
import LandingPage from "./pages/LandingPage";
import Footer from "./components/commonComponents/Footer";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ComingSoon from "./components/commonComponents/ComingSoon";
import CoursesPage from "./pages/CoursesPage";
import GalleryPage from "./pages/GalleryPage";
import AuthPage from "./pages/AuthPage";
import AdmissionPage from "./pages/AdmissionPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PageNotFoundPage from "./pages/PageNotFoundPage";
import AdminDashboard from "./components/dashboards/AdminDashboard";
import StudentDashboard from "./components/dashboards/StudentDashboard";
import StaffDashboard from "./components/dashboards/StaffDashboard";
import PrivateRoute from "./pages/PrivateRoutes";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./features/authSlice"; // Path to your auth slice
import ThankYouPage from "./pages/ThankYou";
import ResetPassword from "./components/otherPageComponent/ResetPassword";

// Component to conditionally render Navbar and Footer
const Layout = ({ children }) => {
  const location = useLocation();

  // Define the paths where Navbar and Footer should NOT appear
  const excludePaths = [
    "/admin-dashboard",
    "/staff-dashboard",
    "/student-dashboard",
  ];

  const shouldRenderNavbarFooter = !excludePaths.includes(location.pathname);

  return (
    <>
      {shouldRenderNavbarFooter && <Navbar />}
      {children}
      {shouldRenderNavbarFooter && <Footer />}
    </>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const selectRole = useSelector((state) => state.auth.role);

  useEffect(() => {
    // Check if the user is already logged in by checking localStorage
    const token = localStorage.getItem("token");
    const role = selectRole;

    if (token && role) {
      dispatch(setUser({ token, role }));
    }
  }, [dispatch]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blogs" element={<ComingSoon />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/events" element={<ComingSoon />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admission" element={<AdmissionPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />

          {/* Private Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute allowedRoles={["admin", "student"]}>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff-dashboard"
            element={
              <PrivateRoute allowedRoles={["staff"]}>
                <StaffDashboard />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/student-dashboard"
            element={
              <PrivateRoute allowedRoles={["student"]}>
                <StudentDashboard />
              </PrivateRoute>
            }
          /> */}

          <Route path="*" element={<PageNotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
